window.Products.Clothing.YogaShorts = function () {}
window.Products.Clothing.YogaShorts.inherits(window.Products.Clothing.Clothing)